var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-logo-container",
      class: { collapse: _vm.collapse },
    },
    [
      _c(
        "transition",
        { attrs: { name: "sidebarLogoFade" } },
        [
          _vm.collapse
            ? _c(
                "router-link",
                {
                  key: "collapse",
                  staticClass: "sidebar-logo-link",
                  attrs: { to: "/" },
                },
                [
                  _c("img", {
                    staticClass: "sidebar-logo",
                    attrs: { src: require("@/assets/images/logole1.png") },
                  }),
                ]
              )
            : _c(
                "router-link",
                {
                  key: "expand",
                  staticClass: "sidebar-logo-link",
                  attrs: { to: "/" },
                },
                [
                  _vm.slideClass === "lightWhite"
                    ? _c("img", {
                        staticClass: "sidebar-logo",
                        attrs: { src: require("@/assets/images/logole1.png") },
                      })
                    : _c("img", {
                        staticClass: "sidebar-logo",
                        staticStyle: { width: "100px", height: "60px" },
                        attrs: { src: require("@/assets/images/logole1.png") },
                      }),
                ]
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }